import { render, staticRenderFns } from "./OrderReport.vue?vue&type=template&id=9105a8f2&"
import script from "./OrderReport.vue?vue&type=script&lang=js&"
export * from "./OrderReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9105a8f2')) {
      api.createRecord('9105a8f2', component.options)
    } else {
      api.reload('9105a8f2', component.options)
    }
    module.hot.accept("./OrderReport.vue?vue&type=template&id=9105a8f2&", function () {
      api.rerender('9105a8f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/OrderReport.vue"
export default component.exports